<template>
  <div>
    <!-- popup view/update student md-->
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupstudentdetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="CloseStudent()"
            />
            Student Details
          </h3>
          <div v-if="popupformstudent === true">
            <div
              class="p-1"
              style="height: 700px; overflow-y: scroll; overflow-x: hidden"
            >
              <label class="custom-16px text-white">Student Name</label>
              <CInput
                type="text"
                class="custom-input-user"
                v-model="StudentNames"
              />
              <label class="custom-16px text-white">Student Email</label>
              <CInput
                type="text"
                class="custom-input-user"
                v-model="StudentEmails"
              />
              <label class="custom-16px text-white">Address</label>
              <CInput type="text" class="custom-input-user" v-model="Address" />
              <label class="custom-16px text-white">IC Number</label>
              <CInput
                type="text"
                class="custom-input-user"
                v-model="IcNumber"
              />
              <CRow class="p-0">
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Grade</label>
                  <v-select
                    v-model="SelectedGradeNames"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                ></CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Class</label>
                  <v-select
                    v-model="SelectedClassNames"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                ></CCol>

                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Gender</label>
                  <!-- <v-select
                    v-model="selectedGradeName"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                > -->
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3"
                    >Date Of birth</label
                  >
                  <!-- <v-select
                    v-model="selectedClassName"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                > -->
                </CCol>

                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Age</label>
                  <!-- <v-select
                    v-model="selectedGradeName"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                > -->
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3"
                    >Mobile Number</label
                  >
                  <!-- <v-select
                    v-model="selectedClassName"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                > -->
                </CCol>
              </CRow>
              <br /><br />

              <div class="text-center">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitSubject()"
                  class="custom-btn-login-active"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccess === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New subject succesfully created!</label>
              <CButton
                color="primary"
                size="lg"
                @click="CloseSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- popup view/update student sm-->
    <div
      class="custom-popup-class-md d-md-none"
      v-if="popupstudentdetail === true"
      style="z-index: 1"
    >
      <div
        style="
          background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <br /><br /><br />
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="CloseStudent()"
            />
            Student Details
          </h3>
          <div v-if="popupformstudent === true">
            <div
              class="p-1"
              style="height: 700px; overflow-y: scroll; overflow-x: hidden"
            >
              <label class="custom-16px text-white">Student Name</label>
              <CInput
                type="text"
                class="custom-input-user"
                v-model="StudentNames"
              />
              <label class="custom-16px text-white">Student Email</label>
              <CInput
                type="text"
                class="custom-input-user"
                v-model="StudentEmails"
              />
              <label class="custom-16px text-white">Address</label>
              <CInput type="text" class="custom-input-user" v-model="Address" />
              <label class="custom-16px text-white">IC Number</label>
              <CInput
                type="text"
                class="custom-input-user"
                v-model="IcNumber"
              />
              <CRow class="p-0">
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Grade</label>
                  <v-select
                    v-model="SelectedGradeNames"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                ></CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Class</label>
                  <v-select
                    v-model="SelectedClassNames"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                ></CCol>

                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Gender</label>
                  <!-- <v-select
                    v-model="selectedGradeName"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                > -->
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3"
                    >Date Of birth</label
                  >
                  <!-- <v-select
                    v-model="selectedClassName"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                > -->
                </CCol>

                <CCol sm="6">
                  <label class="custom-16px text-white mt-3">Age</label>
                  <!-- <v-select
                    v-model="selectedGradeName"
                    :options="gradesName"
                    label="Name"
                    placeholder="--Choose Grade--"
                    class="custom-vselect no-bordered"
                  ></v-select
                > -->
                </CCol>
                <CCol sm="6">
                  <label class="custom-16px text-white mt-3"
                    >Mobile Number</label
                  >
                  <!-- <v-select
                    v-model="selectedClassName"
                    :options="classes"
                    label="Name"
                    placeholder="Choose Class"
                    class="custom-vselect no-bordered"
                  >
                  </v-select
                > -->
                </CCol>
              </CRow>
              <br /><br />

              <div class="text-center">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitSubject()"
                  class="custom-btn-login-active"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccess === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New subject succesfully created!</label>
              <CButton
                color="primary"
                size="lg"
                @click="CloseSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- popup view/update package md-->
    <div
      class="custom-popup-class d-sm-down-none"
      v-if="popupstudentpackage === true"
      style="z-index: 1"
    >
      <div
        style="background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
        "
      >
        <div class="p-3">
          <h3 class="custom-24px text-left text-white mt-2 p-2">
            <img
              src="../assets/img/iconBackWhite.svg"
              class="mr-2"
              @click="ClosePackage()"
            />
            Assign Package
          </h3>
          <div v-if="popupformstudentpackage === true">
            <div
              class="p-1"
              style="height: 700px; overflow-y: scroll; overflow-x: hidden"
            >
              <label class="custom-16px text-white mt-3">Package</label>
              <v-select
                v-model="selectedPackage"
                :options="packages"
                label="Name"
                placeholder="--Please Select Package--"
                class="custom-vselect no-bordered"
              ></v-select>
              <br />
              <label class="custom-16px text-white mt-3">Package Name</label>
              <ul v-for="item in studentpackages" v-bind:key="item.Id">
                <li class="text-white">
                  <CRow>
                    <CCol sm="8">
                      {{ item.Name }}
                    </CCol>
                    <CCol sm="4">
                      <CButton
                    type="button"
                    class="btn btn-danger"
                    @click="OpenDeletePackages(item)"
                  >
                    <CIcon name="cil-trash"
                  /></CButton>
                    </CCol>
                  </CRow> </li>

              </ul>
             

              <div class="text-center">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitSubject()"
                  class="custom-btn-login-active"
                  >Save
                </CButton>
                <br /><br />
              </div>
            </div>
          </div>
          <div v-if="popupsuccess === true">
            <div class="text-center" style="margin-top: 25%">
              <img src="../assets/img/checked.svg" />
              <h3 class="text-white">You're All Set !</h3>
              <label class="text-white">New subject succesfully created!</label>
              <CButton
                color="primary"
                size="lg"
                @click="CloseSubject()"
                class="custom-btn-login-active"
                >Close
              </CButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h3 class="header-title">
      <img
        src="../assets/img/iconBack.svg"
        class="mr-2"
        @click="GoToClass()"
      />Learning Setting
    </h3>
    <br />
    <CRow class="mt-1">
      <CCol sm="12">
        <CTabs class="m-2">
          <CTab title="Students" active>
            <CRow>
              <CCol sm="10">
                <CInput
                  type="text"
                  placeholder="Search...."
                  v-model.lazy="SearchQuery"
                  class="mt-2"
                />
              </CCol>
              <CCol sm="2">
                <CButton
                  type="button"
                  color="primary"
                  class="custom-bg-blue float-right mr-4 mb-2 mt-2"
                  >+ Create
                </CButton>
              </CCol>
            </CRow>

            <CCol sm="12">
              <div>
                <CCard class="custom-explore text-white p-3 m-2">
                  <CRow>
                    <CCol sm="1">ID No.</CCol>
                    <CCol sm="2">Profile</CCol>
                    <CCol sm="2">Student Detail</CCol>
                    <CCol sm="3">Package</CCol>
                    <CCol sm="2">Fee</CCol>
                    <CCol sm="2">Status</CCol>
                  </CRow>
                </CCard>
                <div v-if="Busy == true">
                  <CCol sm="12" md="12">
                    <div class="app flex-row align-items-center">
                      <div class="container d-flex justify-content-center">
                        <PulseLoader float />
                      </div>
                    </div>
                  </CCol>
                </div>
                <div v-else>
                  <div>
                    <CCol sm="12">
                      <CCard
                        v-for="item in FilteredStudentsList"
                        v-bind:key="item.Id"
                        class="p-2 custom-box-shadow"
                      >
                        <CRow>
                          <CCol sm="1">
                            <label>
                              <b class="text-blue-color">{{ item.Id }}</b>
                              <span v-if="item.DateRegister === currentDate">
                                <img
                                  style="height: 20px"
                                  src="../assets/img/new.svg"
                                  class="ml-2 mr-2"
                                />
                              </span>
                            </label>
                          </CCol>
                          <CCol sm="2">
                            <img
                              v-if="item.profileImagePath == null"
                              style="
                                border: 1px solid #eee;
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                object-fit: cover;
                              "
                              src="../assets/img/default.png"
                              class="grey lighten-2 mt-2"
                            />

                            <img
                              v-else
                              style="
                                border: 3px solid #ddd;
                                background: #fff;
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                                object-fit: cover;
                              "
                              :src="getPicChild(item)"
                              class="grey lighten-2 mt-2"
                            />
                          </CCol>
                          <CCol sm="2">
                            <h6 class="text-uppercase text-blue-color">
                              {{ item.Name }}
                            </h6>
                            <div class="small text-muted">
                              <b>Parent Name :</b> {{ item.ParentName }} /
                              {{ item.ParentEmail }}
                            </div>
                            <div class="small text-muted">
                              <b> Grade :</b> {{ item.Grade }}
                            </div>
                            <div class="small text-muted">
                              <b> Class :</b> {{ item.Class }}
                            </div>
                            <div class="small text-muted">
                              <b>Contact : </b>{{ item.Phone }}
                            </div>
                            <div class="small text-muted">
                              <b> Registered :</b>
                              {{ item.Register | moment("MMM YYYY") }}
                            </div></CCol
                          >
                          <CCol sm="3">
                            <tr v-for="su in item.Packages" :key="su.Id">
                              <li>{{ su.Name }} - {{ su.StudentFee }}</li>
                            </tr>
                          </CCol>
                          <CCol sm="2"
                            ><strong style="color: #1e109c"
                              >RM {{ item.TotalFee - item.Discount }}</strong
                            ></CCol
                          >
                          <CCol sm="2">
                            <div v-if="item.Status === 'active'">
                              <img src="../assets/img/Iconcheck.png" /><span
                                class="text-green-color ml-2"
                                >Active</span
                              >
                            </div>
                            <div v-if="item.Status === 'deleted'">
                              <img src="../assets/img/Icondeleted.png" /><span
                                class="text-red-color ml-2"
                                >Deleted</span
                              >
                            </div>
                            <div v-if="item.Status === 'inactive'">
                              <img src="../assets/img/Icondeleted.png" /><span
                                class="text-red-color ml-2"
                                >Deleted</span
                              >
                            </div>
                            <div v-if="item.Status === 'removed'">
                              <img src="../assets/img/Icondeleted.png" /><span
                                class="text-red-color ml-2"
                                >Deleted</span
                              >
                            </div>

                            <div
                              style="position:absolute:top:0px"
                              class="float-right"
                            >
                              <CDropdown color="link" size="lg" :caret="false">
                                <template #toggler-content>
                                  <img src="../assets/img/dots-vertical.svg" />
                                </template>
                                <CDropdownItem @click="OpenAssignPackage(item)"
                                  >Assign Package</CDropdownItem
                                >
                                <hr />
                                <CDropdownItem @click="OpenUpdate(item)"
                                  >View</CDropdownItem
                                >
                                <CDropdownItem @click="OpenUpdateStudent(item)"
                                  >Edit</CDropdownItem
                                >
                                <CDropdownItem @click="OpenRemove(item)"
                                  >Remove</CDropdownItem
                                >
                              </CDropdown>
                            </div>
                          </CCol>
                        </CRow>
                      </CCard>
                      <!-- <jw-pagination
                        :items="FilteredStudents"
                        @changePage="onChangePage"
                        :labels="customLabels"
                      ></jw-pagination> -->
                    </CCol>
                  </div>
                </div>
              </div>
            </CCol>
          </CTab>
          <CTab title="Teachers">
            <CRow>
              <CCol sm="10">
                <CInput
                  type="text"
                  placeholder="Search...."
                  v-model.lazy="SearchQueryTeacher"
                  class="mt-2"
                  @change="ApplyFilter()"
                />
              </CCol>
              <CCol sm="2">
                <CButton
                  type="button"
                  color="primary"
                  class="custom-bg-blue float-right mr-4 mb-2 mt-2"
                  >+ Create
                </CButton>
              </CCol>
            </CRow>
            <div>
              <CCard class="custom-explore text-white p-3 m-2">
                <CRow>
                  <CCol sm="1">ID. No</CCol>
                  <CCol sm="1">Profile</CCol>
                  <CCol sm="3">Teacher Detail</CCol>
                  <CCol sm="3">Subject</CCol>
                  <CCol sm="2">Rate</CCol>
                  <CCol sm="2">Status</CCol>
                </CRow>
              </CCard>
              <div>
                <CCol sm="12">
                  <CCard
                    v-for="item in FilteredTeacherList"
                    v-bind:key="item.Id"
                    class="p-2 custom-box-shadow"
                  >
                    <CRow>
                      <CCol sm="1">
                        <label>
                          <b class="text-custom-primary"> {{ item.Id }}</b>
                          <span v-if="item.CreatedTime === currentDate">
                            <img
                              style="height: 20px"
                              src="../assets/img/new.svg"
                              class="ml-2 mr-2"
                            />
                          </span>
                        </label>
                      </CCol>
                      <CCol sm="1">
                        <img
                          v-if="item.profileImagePath == null"
                          style="
                            border: 1px solid #eee;
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            object-fit: cover;
                          "
                          src="../assets/img/default.png"
                          class="grey lighten-2 mt-2"
                        />

                        <img
                          v-else
                          style="
                            border: 3px solid #ddd;
                            background: #fff;
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                            object-fit: cover;
                          "
                          :src="getPic(item)"
                          class="grey lighten-2 mt-2"
                        />
                      </CCol>
                      <CCol sm="3">
                        <td>
                          <h6 class="text-uppercase text-blue-color">
                            {{ item.Name }}
                          </h6>
                          <div class="small text-muted">
                            <b>Contact :</b> {{ item.Email }} / {{ item.Phone }}
                          </div>
                          <div class="small text-muted">
                            <b> Registered :</b>
                            {{ item.CreatedTime | moment("MMM YYYY") }}
                          </div>
                        </td>
                      </CCol>
                      <CCol sm="3">
                        <tr v-for="item in item.Subject" v-bind:key="item.Id">
                          <td>{{ item.Name }}</td>
                        </tr>
                      </CCol>
                      <CCol sm="2">
                        <tr v-for="item in item.Subject" v-bind:key="item.Id">
                          <td>{{ item.Hour }} hour / RM {{ item.Rate }}</td>
                        </tr>
                      </CCol>
                      <CCol sm="2">
                        <div v-if="item.Status === 'active'">
                          <img src="../assets/img/Iconcheck.png" /><span
                            class="text-green-color ml-2"
                            >Active</span
                          >
                        </div>
                        <div v-if="item.Status === 'deleted'">
                          <img src="../assets/img/Icondeleted.png" /><span
                            class="text-red-color ml-2"
                            >Deleted</span
                          >
                        </div>
                        <div v-if="item.Status === 'inactive'">
                          <img src="../assets/img/Icondeleted.png" /><span
                            class="text-red-color ml-2"
                            >Deleted</span
                          >
                        </div>
                        <div v-if="item.Status === 'removed'">
                          <img src="../assets/img/Icondeleted.png" /><span
                            class="text-red-color ml-2"
                            >Deleted</span
                          >
                        </div>
                        <div
                          style="position:absolute:top:0px"
                          class="float-right"
                        >
                          <CDropdown color="link" size="lg" :caret="false">
                            <template #toggler-content>
                              <img src="../assets/img/dots-vertical.svg" />
                            </template>
                            <CDropdownItem @click="OpenUpdate(item)"
                              >View</CDropdownItem
                            >
                            <CDropdownItem @click="OpenUpdate(item)"
                              >Edit</CDropdownItem
                            >
                            <CDropdownItem @click="OpenRemove(item)"
                              >Remove</CDropdownItem
                            >
                          </CDropdown>
                        </div>
                      </CCol>
                    </CRow>
                  </CCard>
                  <!-- <jw-pagination
                    :items="FilteredTeachers"
                    @changePage="onChangePageTeacher"
                    :labels="customLabels"
                  ></jw-pagination> -->
                </CCol>
              </div>
            </div>
          </CTab>
        </CTabs>
      </CCol>
    </CRow>
  </div>
</template>
  
  
  
  
  <script>
import Vue from "vue";
import _ from "lodash";

Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import JwPagination from "jw-vue-pagination";
Vue.component("jw-pagination", JwPagination);

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};
export default {
  name: "Tables",
  components: {
    PulseLoader,
  },
  data() {
    return {
      Busy: false,
      customLabels,
      students: [],
      teachers: [],

      FilteredTeachers: [],
      FilteredStudents: [],
      pageOfItems: [],
      SearchQuery: "",

      popupstudentdetail: false,
      popupformstudent: true,
      popupsuccess: false,

      selectedGradeName: "",
      SelectedGradeName: "",
      gradesName: [],
      classes: [],
      StudentNames: "",
      StudentEmails: "",
      SelectedGradeNames: "",
      SelectedClassNames: "",
      Address: "",
      IcNumber: "",

      SearchQueryTeacher: "",

      popupstudentpackage: false,
      popupformstudentpackage: true,

      selectedPackage: "",
      packages: [],

      studentDetails: [],
      studentpackages: [],
      FilteredStudentPackages: [],

      fieldsPackages: [{ key: "Name" }, { key: "Action" }],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetStudent();
      this.GetTeacher();
      this.currentDate();
      this.GetClass();
      this.GetGrade();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    FilteredStudentsList() {
      if (this.SearchQuery === "") return this.FilteredStudents;
      return this.FilteredStudents.filter((item) => {
        //teacher name
        for (const { Name } of item.Packages) {
          if (Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1) {
            return item;
          }
        }

        if (
          item.Name.toLowerCase().indexOf(this.SearchQuery.toLowerCase()) > -1
        ) {
          return item;
        }

        if (
          item.ParentName.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        if (
          item.ParentEmail.toLowerCase().indexOf(
            this.SearchQuery.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        const fee = item.Phone?.toString() || "";
        if (fee.indexOf(this.SearchQuery.toString()) > -1) {
          return item;
        }
      });
    },
    FilteredTeacherList() {
      if (this.SearchQueryTeacher === "") return this.FilteredTeachers;
      return this.FilteredTeachers.filter((item) => {
        //teacher name
        for (const { Name } of item.Subject) {
          if (
            Name.toLowerCase().indexOf(this.SearchQueryTeacher.toLowerCase()) >
            -1
          ) {
            return item;
          }
        }

        if (
          item.Name.toLowerCase().indexOf(
            this.SearchQueryTeacher.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        if (
          item.Phone.toLowerCase().indexOf(
            this.SearchQueryTeacher.toLowerCase()
          ) > -1
        ) {
          return item;
        }

        if (
          item.Email.toLowerCase().indexOf(
            this.SearchQueryTeacher.toLowerCase()
          ) > -1
        ) {
          return item;
        }
      });
    },
  },
  methods: {
    currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${
        current.getMonth() + 1
      }/${current.getFullYear()}`;
      console.log("time" + date);
      return date;
    },
    onChangePage(students) {
      // update page of items
      this.students = students;
    },
    onChangePageTeacher(teachers) {
      // update page of items
      this.teachers = teachers;
    },
    GetStudent() {
      this.Busy = true;
      this.$API
        .get(this.$ViewStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.students = response.data;
            this.getPicChild(this.students);
            this.FilteredStudents = this.students;
          }
        });
    },
    getPicChild(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },
    GetTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teachers = response.data;
            this.getPic(this.teachers);
            this.FilteredTeachers = this.teachers;
          }
        });
    },
    getPic(item) {
      return "https://pickiddo.com" + item.profileImagePath;
    },
    GoToClass() {
      this.$router.push("LearningClass");
    },
    GetClass() {
      this.$API
        .get(this.$ListClassTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });
    },

    GetGrade() {
      this.$API
        .get(this.$ListGradeTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.gradesName = response.data;
          }
        });
    },
    OpenUpdateStudent(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.StudentNames = this.info.Name;
            this.StudentEmails = this.info.StudentEmail;
            this.ParentNames = this.info.ParentName;
            this.ParentEmails = this.info.ParentEmail;
            this.ParentPhoneNumbers = this.info.ParentPhoneNumber;
            this.Grades = this.info.Grade;
            this.ClassNames = this.info.Class;
            this.RateTypes = this.info.RateType;
            this.Address = this.info.StudentRegInfo[0].Address;
            this.IcNumber =
              this.info.StudentRegInfo[0].IdentityCertificateNumber;

            this.SetupSelectedOption();
          }
        });
      this.popupstudentdetail = true;
    },
    CloseStudent() {
      this.popupstudentdetail = false;
    },
    ApplyFilter: function () {
      var arr = _.orderBy(this.teachers, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ Name, Phone, Email }) =>
          _.some([
            _.includes(!Name || Name.toLowerCase(), [
              this.SearchQueryTeacher.toLowerCase(),
            ]),
            _.includes(!Phone || Phone.toLowerCase(), [
              this.SearchQueryTeacher.toLowerCase(),
            ]),
            _.includes(!Email || Email.toLowerCase(), [
              this.SearchQueryTeacher.toLowerCase(),
            ]),
          ])
        );
        this.FilteredTeachers = result;
      }
    },
    SetupSelectedOption() {
      this.$forceUpdate();
      this.SelectedGradeNames = _.find(this.gradesName, {
        Name: this.Grades,
      });
      this.SelectedClassNames = _.find(this.classes, {
        Name: this.ClassNames,
      });
    },

    OpenAssignPackage(item) {
      this.StudentId = item.Id;

      this.$API
        .get(this.$StudentDetailByIdAuthorize + "?id=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });

      this.$API
        .get(this.$ViewPackage, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.packages = response.data;
          }
        });

      this.$API
        .get(this.$GetListStudentPackage + "?manualId=" + this.StudentId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.studentpackages = response.data;
            FilteredStudentPackages = this.studentpackages;
          }
        });

      this.popupstudentpackage = true;
    },
    OpenDeletePackages(item) {
      const formData = new FormData();

      formData.append("Id", item.Id);

      return this.$API
        .post(this.$DeleteStudentPackage, formData, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            this.$dialog.alert("Details Deleted!");
            this.AssignPackageModal = false;
          } else console.log("Error Deleting");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ClosePackage()
    {
      this.popupstudentpackage = false;
    }
  },
};
</script>
<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100&family=Rubik:ital,wght@0,300;0,400;1,300;1,400&display=swap" rel="stylesheet"></link>
 <<style scoped>
 .c-app {
  /* font-family: montserrat, Sans-serif; */
  font-family: 'Rubik', sans-serif !important;
}
 </style>